module.exports = __webpack_public_path__ + "img/qgew-3_125-300.prt.db0389a7.jpg";